/* Copyright (c) 2021 VMware, Inc. All rights reserved. VMware Confidential */

import { Location } from "@angular/common";
import { FactoryProvider } from "@angular/core";
import { OAuth2ModuleConfiguration } from "@vmw/ngx-csp-oauth2";
import { AppConfigService } from "@app/services/app-config/app-config.service";

/**
 * This factory generates an OAuth2ModuleConfiguration based on the current
 * runtime environment of the application.
 */
export function authConfigurationFactory(location: Location, config: AppConfigService): OAuth2ModuleConfiguration {
    const origin: string = window.location.origin;
    const redirectUri: string = origin + location.prepareExternalUrl("/oauth2/callback");
    const cspOAuthConfig: Partial<OAuth2ModuleConfiguration> = config.cspOAuthConfig;
    return {
        ...cspOAuthConfig,
        redirectUri,
        noServiceAccessRoute: "oauth2/error" // error 403
    } as OAuth2ModuleConfiguration;
}

/**
 * Injectable provider for the root application.
 */
export const AuthConfigurationProvider: FactoryProvider = {
    provide: OAuth2ModuleConfiguration,
    useFactory: authConfigurationFactory,
    deps: [Location, AppConfigService]
};
